import {createClient} from '@sanity/client'

// Log environment variables right before creating the client
// console.log('Reading Environment Variables for Sanity Client:');
// console.log('REACT_APP_SANITY_PROJECT_ID:', process.env.REACT_APP_SANITY_PROJECT_ID);
// console.log('REACT_APP_SANITY_DATASET:', process.env.REACT_APP_SANITY_DATASET);
// console.log('REACT_APP_SANITY_USE_CDN:', process.env.REACT_APP_SANITY_USE_CDN);
// console.log('REACT_APP_SANITY_API_VERSION:', process.env.REACT_APP_SANITY_API_VERSION);
// console.log('REACT_APP_SANITY_TOKEN:', process.env.REACT_APP_SANITY_TOKEN);

const client = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET,
  useCdn: process.env.REACT_APP_SANITY_USE_CDN === 'true',
  apiVersion: process.env.REACT_APP_SANITY_API_VERSION,
  token: process.env.REACT_APP_SANITY_TOKEN
  // projectId: 'a6njo3ya', // <-- REPLACE THIS
  // dataset: 'testing',         // <-- Or 'production' if needed
  // useCdn: true,               // Or false
  // apiVersion: '2024-03-20',   // Use a valid date
  // token: 'skKiuJIKSU0mL2s6nkRiWNjp7ECSUHO2zv6qj5giiExAFlHYx9kCsKcm5uozbmuP8pFWFPldJLC9whTsnDLXcgJJqh9Bwh4cKtCKsYZrLl3gBKvbC1wSvPy3IMKURB0PasGyPvzfRSBbowYrwqiOMr1PJxKfCZosNnWESrmfU6qhDzwxx3pU' // <-- REPLACE THIS (or remove line if dataset is public)
})

export default client 